import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fdc6b3d0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc6b3d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\java\\project\\fenxijunya-java\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fdc6b3d0')) {
      api.createRecord('fdc6b3d0', component.options)
    } else {
      api.reload('fdc6b3d0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=fdc6b3d0&scoped=true", function () {
      api.rerender('fdc6b3d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/group/index.vue"
export default component.exports